var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.colGrid},[_c('div',{staticClass:"card card-estilo p-grid p-fluid",class:_vm.getClass},[(_vm.titulo)?_c('h1',{staticClass:"p-col-12"},[_vm._v(_vm._s(_vm.titulo))]):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }